import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'smart_banner.title',
  },
  subTitle: {
    id: 'smart_banner.sub_title',
  },
});
